module.exports = __webpack_public_path__ + "static/media/6.16_preview.8ad70976.png";